import { Box } from "@mui/system"
import React from "react"
import Footer from "../Footer/Footer"
import Navbar from "../Navigation/Navbar"

interface Props {
    children: React.ReactNode,
    isNotFound?: boolean
}

const Layout: React.FC<Props> = ({ children, isNotFound = false }) => {
    return (
        <Box>
            <Navbar isNotFound= {isNotFound}/>
                {children}
            <Footer />
        </Box>
    )
}

export default Layout